
export type PAGE_LOADED_TYPE = 'WORKFORCE_PAGE_LOADED';
export const PAGE_LOADED = 'WORKFORCE_PAGE_LOADED';
export interface WorkforceOnePageLoadedAction{
    type: PAGE_LOADED_TYPE
}
export function PageLoaded(): WorkforceOnePageLoadedAction{
    return {
        type: PAGE_LOADED,
    }
}


export type WorkforceOnePageActions = | WorkforceOnePageLoadedAction;

